import React from 'react';
import '../../App.css';
import CardGrid from "../CardGrid.js"

export default function Home() {
  const isSaral = process.env.REACT_APP_CLIENT_NAME === 'SARAL TRANSPORT';
  const isAmbikapur =
    process.env.REACT_APP_CLIENT === "ase";

  const ambikapurBgStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/bg.jpeg)`,
    backgroundAttachment: "fixed",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "50%",
    backgroundColor: "#d6d8d5",
    width: "100%",
    minHeight: "100vh",
  };

  return (
    <div
      className={isAmbikapur ? "home" : isSaral ? "home-saral" : "home"}
      style={isAmbikapur ? ambikapurBgStyle : undefined}
    >
      <CardGrid />
    </div>
  );
}
